import { lines } from './recipes'

// Cook mode's pages, one at a time: what to get out first (when the recipe lists anything), then each step as it was
// written, then the end. A recipe kept only as a photo of its card has no pages: it's cooked from the card.
export type CookPage =
  { kind: 'ingredients'; lines: string[] } | { kind: 'step'; n: number; text: string } | { kind: 'done' }

export function cookPages(recipe: { ingredients: string; steps: string }): CookPage[] {
  const ingredients = lines(recipe.ingredients)
  const steps = lines(recipe.steps)
  if (!ingredients.length && !steps.length) return []
  return [
    ...(ingredients.length ? [{ kind: 'ingredients' as const, lines: ingredients }] : []),
    ...steps.map((text, i) => ({ kind: 'step' as const, n: i + 1, text })),
    { kind: 'done' as const },
  ]
}

// Where a swipe or a key takes you, kept within the pages.
export const stepTo = (at: number, by: number, pages: number) => Math.max(0, Math.min(pages - 1, at + by))
